import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { instanceMob, Loadingspinner } from "../../utils/utils";
import CardBiometrics from "./components/card-biometrics";
import debounce from "./functions/debounce";
import FormField from "../forms/form-field";
import InfoModal from "../info-modal/infoModal";
import { getBackendError } from "../../utils/error-helpers";

const MobBiometrics = () => {
    const [listDevices, setListDevices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [dataBackup, setDataBackup] = useState([]);
    const [locations, setLocations] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({ title: "", description: "", iconType: "success" });

    const showAlert = (title, description, iconType) => {
        setModalData({ title, description, iconType });
        setShowModal(true);
    };

    function getDevices() {
        setIsLoading(true);
        // Hardcoded for now until API is ready, or use instanceMob if endpoint exists
        instanceMob
            .get(`/biometrics`)
            .then((res) => res.data)
            .then((data) => {
                // Assuming data is an array of devices
                const devices = Array.isArray(data) ? data : data.results || [];
                setListDevices(devices);
                setDataBackup(devices);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
                setListDevices([]);
                showAlert("Error de Conexión", "No se pudieron cargar los dispositivos: " + getBackendError(err), "error");
            });
    }

    function getLocations() {
        instanceMob
            .get(`/admin/location/list`)
            .then((res) => res.data)
            .then((data) => {
                const locs = Array.isArray(data) ? data : data.results || [];
                setLocations(locs);
            })
            .catch((err) => {
                console.error("Error fetching locations:", err);
                if (showAlert) showAlert("Error de Configuración", "No se pudieron cargar las locaciones: " + getBackendError(err), "error");
            });
    }

    function searchDevices(e) {
        let valueLower = e.target.value.toLowerCase();
        if (valueLower === "") {
            setListDevices(dataBackup);
        } else {
            const filtered = dataBackup.filter(device =>
                (device.name && device.name.toLowerCase().includes(valueLower)) ||
                (device.serial && device.serial.toLowerCase().includes(valueLower)) ||
                (device.location?.name && device.location.name.toLowerCase().includes(valueLower))
            );
            setListDevices(filtered);
        }
    }

    useEffect(() => {
        if (localStorage.mob_api_key) {
            getDevices();
            getLocations();
        }
    }, []);

    return (
        <div className="w-100 animate-fade-in p-2">
            <div className="d-flex flex-column flex-md-row w-100 justify-content-between align-items-center mb-5 mt-2 gap-3 px-3">
                <div className="text-start">
                    <h4 className="fw-bold mb-1 biometrics-page-title" style={{ letterSpacing: '-0.02em' }}>Dispositivos Biométricos</h4>
                    <p className="text-muted mb-0 small">Gestiona y monitorea los dispositivos de acceso de tu gimnasio</p>
                </div>

                <div className="d-flex align-items-center gap-3">
                    <FormField
                        type="search"
                        placeholder="Buscar por nombre o ID..."
                        onChange={debounce(searchDevices, 500)}
                        width="300px"
                    />
                </div>
            </div>

            {isLoading ? (
                <div className="d-flex flex-column align-items-center justify-content-center py-5 gap-3">
                    <Loadingspinner customStyle="grow" size="3rem" />
                    <span className="text-muted fw-medium animate-pulse">Sincronizando dispositivos...</span>
                </div>
            ) : (
                <div
                    style={{ height: "calc(100vh - 18rem)", overflowY: "auto" }}
                    className="px-3 w-100"
                >
                    {listDevices.length > 0 ? (
                        <Row className="g-4 pb-4 m-0 w-100">
                            {listDevices.map((device, index) => (
                                <Col key={`dev-${device.id || index}`} xs={12} sm={6} lg={4} xl={3}>
                                    <CardBiometrics
                                        device={device}
                                        locations={locations}
                                        onUpdate={getDevices}
                                        onShowAlert={showAlert}
                                    />
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <div className="d-flex flex-column align-items-center justify-content-center mt-5 text-center px-4 py-5 bg-white border border-light mx-auto"
                            style={{ maxWidth: '600px', backgroundColor: '#ffffff' }}>
                            <div className="mb-4 p-4 rounded-circle bg-light d-flex align-items-center justify-content-center"
                                style={{ width: '100px', height: '100px' }}>
                                <i className="bi bi-fingerprint text-primary opacity-25" style={{ fontSize: '3rem' }}></i>
                            </div>
                            <h5 className="fw-bold text-dark mb-2">No hay dispositivos registrados</h5>
                            <p className="text-muted mb-4 px-lg-5">
                                Parece que aún no has vinculado ningún lector biométrico. Los dispositivos aparecerán aquí una vez que sean configurados para el acceso.
                            </p>
                        </div>
                    )}
                </div>
            )}

            {showModal && (
                <InfoModal
                    title={modalData.title}
                    description={modalData.description}
                    iconType={modalData.iconType}
                    primaryAction={{
                        label: "Entendido",
                        onClick: () => setShowModal(false)
                    }}
                />
            )}
        </div>
    );
};

export default MobBiometrics;
